<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-23 20:28:22
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-30 18:25:31
-->
<template>
	<el-form :model="formData" label-width="130px" ref="form" :rules="rules" hide-required-asterisk>
		<el-form-item label="招商方式">
			<el-radio-group v-model="formData['activity_type']" @change="val => shopTypeChange('activity_type', val)">
				<el-radio :label="1"><span class="label-width">全部商家</span></el-radio>
				<el-radio :label="2"><span class="label-width">指定商家</span></el-radio>
			</el-radio-group>
			<div v-if="showTextArea">
				<special-shop-form ref="specialShopForm"></special-shop-form>
			</div>
		</el-form-item>
		<el-form-item label="报名门槛" v-if="!showTextArea">
			<el-radio-group v-model="formData['application_limited']">
				<el-radio :label="false"><span class="label-width">无限制</span></el-radio>
				<el-radio :label="true"><span class="label-width">设置报名门槛</span></el-radio>
			</el-radio-group>
			<div v-if="formData.application_limited" class="limitArea">
				<limit-form ref="limitForm"></limit-form>
			</div>
		</el-form-item>
		<el-form-item label="活动名称" prop="activity_name">
			<el-input
				v-model="formData['activity_name']"
				placeholder="请填写"
				style="width: 400px"
				maxlength="30"
				show-word-limit
				resize="none"
				@input="val => change('activity_name', val)"
			></el-input>
		</el-form-item>
		<el-form-item label="活动要求" prop="activity_desc">
			<el-input
				type="textarea"
				v-model="formData['activity_desc']"
				placeholder="请填写活动要求，该要求内容会展示给商家"
				rows="5"
				style="width: 400px"
				maxlength="200"
				show-word-limit
				@input="val => change('activity_desc', val)"
			></el-input>
		</el-form-item>
		<el-form-item prop="apply_end_time">
			<span class="flex" slot="label">报名截止时间<explain content="商家可在活动上线当天至所设报名截止时间当天内提报商品参与招商"></explain></span>
			<el-date-picker
				:pickerOptions="pickerOptions"
				v-model="formData['apply_end_time']"
				placeholder="请选择日期"
				style="width: 400px"
				format="yyyy/MM/dd"
				@change="val => change('apply_end_time', val)"
			></el-date-picker>
		</el-form-item>
		<el-form-item>
			<span class="flex" slot="label">最短推广周期<explain content="报名此招商活动商品的最短推广时间要求"></explain></span>
			<el-select v-model="formData['min_promotion_days']" placeholder="请选择" :style="{ width: '400px' }">
				<el-option v-for="item in promotionPeriodList" :key="item.value" :value="item.value" :label="item.label"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item prop="min_exclusion_duration">
			<span class="flex" slot="label"
				>最短团长保护期<explain
					content="若团长保护期>0个月，本团长首次撮合的达人（通过本团长首次添加本活动商品至橱窗），在保护期间通过本团长链接或该商品普通链接出单，均计算当前团长服务费（保护期到期或者推广结束后，保护机制不生效）"
				></explain
			></span>
			<el-input
				resize="none"
				placeholder="请输入0-6正整数"
				style="width: 400px"
				v-model="formData['min_exclusion_duration']"
				@input="val => change('min_exclusion_duration', val)"
			>
				<template slot="append">个月</template>
			</el-input>
		</el-form-item>
	</el-form>
</template>
<script>
import { checkPromotionProtect } from '@/utils/validate';
const commonRules = {
	activity_name: [{ required: true, message: '活动名称不可为空' }],
	activity_desc: [{ required: true, message: '活动要求不可为空' }],
	apply_end_time: [{ required: true, message: '报名截止时间不可为空' }],
	min_exclusion_duration: [{ requied: false }, { validator: checkPromotionProtect, trigger: 'blur', msg: '请输入0-6的整数' }],
};
import LimitForm from './components/limitForm';
import SpecialShopForm from './components/specialShopForm';
import Explain from '@/components/common/explain';
import { format, startOfDay } from 'date-fns';
import mixin from '../../mixin';
export default {
	name: 'BaseInfoForm',
	mixins: [mixin],
	data() {
		return {
			formData: {
				activity_type: 1,
				application_limited: false,
				activity_name: '',
				activity_desc: '',
				apply_end_time: '',
				min_promotion_days: 30,
				min_exclusion_duration: '',
			},
			promotionPeriodList: [
				{
					label: '30天',
					value: 30,
				},
				{
					label: '90天',
					value: 90,
				},
				{
					label: '180天',
					value: 180,
				},
				{
					label: '360天',
					value: 360,
				},
			],
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < startOfDay(Date.now());
				},
			},
			rules: { ...commonRules },
		};
	},
	computed: {
		showTextArea() {
			return this.formData['activity_type'] === 2;
		},
		showLimitForm() {
			return this.formData['application_limited'];
		},
	},
	methods: {
		validate() {
			return new Promise((resolve, reject) => {
				this.$refs.form.validate(async valid => {
					if (valid) {
						let _form = { ...this.formData };
						// 格式化报名截止时间为yyyy/MM/dd
						_form.apply_end_time = format(_form.apply_end_time, 'yyyy/MM/dd');
						// 指定商家时需要将商家数据结合一起返回，全部商家时不处理
						if (this.formData.activity_type === 2) {
							try {
								const specifiedShop = await this.$refs.specialShopForm.validate();
								_form = { ..._form, ...specifiedShop };
							} catch (error) {
								reject(error);
							}
						}
						// 设置为有门槛时需要将有门槛表单数据结合一起返回，没有门槛时直接返回
						if (this.formData.application_limited) {
							try {
								const limitForm = await this.$refs.limitForm.validate();
								_form = { ..._form, ...limitForm };
							} catch (error) {
								reject(error);
							}
						}
						resolve(_form);
					} else {
						reject(valid);
						return false;
					}
				});
			});
		},
		resetForm() {
			this.$refs.form.resetFields();
		},
		isFormModified() {
			const isModified = [this.$refs?.limitForm?.isFormModified(), this.$refs?.specialShopForm?.isFormModified(), this.isModified].includes(true);
			return isModified;
		},
		shopTypeChange(key, val) {
			// 切换到指定商铺时因为指定商铺表单重新加载，需要将原指定商铺数据清空
			const result = val === 2 ? { [key]: val, specified_shop_ids: '' } : { [key]: val };
			// 切换为指定商铺时需要将报名门槛设置为false
			val === 2 && (this.formData.application_limited = false);
			this.$Bus.$emit('requiredItemChange', result);
		},
	},
	components: {
		LimitForm,
		SpecialShopForm,
		Explain,
	},
};
</script>
<style lang="less">
.label-width {
	display: inline-block;
	width: 58px;
}
.limitArea {
	margin-top: 10px;
	padding: 10px 0;
	background: fadeout(@color-primary, 95%);
	border-radius: 4px;
}
</style>